/**
 * One API slice; endpoints are injected per backend router (`./endpoints/*`), so this
 * directory mirrors `apps/api/routers/` and there is exactly one obvious place per call.
 *
 * Cache tags carry the engine's own causality rather than a per-endpoint guess: arming a
 * campaign changes its leads, its queue and its stats, so `activate` invalidates all
 * three and every open screen catches up without anyone wiring a refresh.
 */

import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './baseQuery'

export const api = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: [
    'Campaign',
    'CampaignStats',
    'Schedule',
    'Activity',
    'Lead',
    'Account',
    'AccountReads',
    'Conversation',
    'Thread',
    'InboxFolder',
    'Pull',
    'Table',
    'TableRows',
    'Recipe',
    'Classifier',
    // Email (Smartlead) and the approvals queue.
    'CampaignAnalytics',
    'EmailOverview',
    // Email days copied from Smartlead into our table (BIBLE §14).
    'EmailDays',
    'Warmup',
    'Proposal',
    // Clients (BIBLE §19).
    'Client',
    // A client's dashboard logins (BIBLE §19.5).
    'ClientUser',
  ],
  // Back-navigation should be instant, and a campaign list is small. Five minutes is long
  // enough to make the console feel local and short enough that a stale tab catches up.
  keepUnusedDataFor: 300,
  endpoints: () => ({}),
})
